<div style="text-align:center;padding-top:10px" *ngIf="physicalExamScreenings.length == 0  && isBusy==false" translate>
    No Physical Exam data exists for student
</div>
<div *ngIf="physicalExamScreenings.length > 0 ">
    <mat-table [dataSource]="angularMatData" matSort matSortDisableClear matSortActive="Date" matSortDirection="desc"
        style="display: grid">
        <ng-container matColumnDef="Date">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Date
                <filter class="mat-filter" [data]="angularMatData" columnName="Date" dataType="date"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span *ngIf="row.Date != null && row.Date != '0001-01-01T00:00:00'">
                    {{row.Date|date:'MM/dd/yyyy'}}
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Height">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Height
                <filter class="mat-filter" [data]="angularMatData" columnName="Height" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.Height}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="HeightPercentile">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Height Percentile
                <filter class="mat-filter" [data]="angularMatData" columnName="HeightPercentile" dataType="number">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.HeightPercentile}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Weight">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Weight
                <filter class="mat-filter" [data]="angularMatData" columnName="Weight" dataType="number">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.Weight}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="WeightPercentile">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Weight Percentile
                <filter class="mat-filter" [data]="angularMatData" columnName="WeightPercentile" dataType="number">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.WeightPercentile}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="BMI">
            <mat-header-cell *matHeaderCellDef mat-sort-header>BMI
                <filter class="mat-filter" [data]="angularMatData" columnName="BMI" dataType="number">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.BMI}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="BMIPercentile">
            <mat-header-cell *matHeaderCellDef mat-sort-header>BMI Percentile
                <filter class="mat-filter" [data]="angularMatData" columnName="BMIPercentile" dataType="number">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.BMIPercentile}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="BloodPressure">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Blood Pressure
                <filter class="mat-filter" [data]="angularMatData" columnName="BloodPressure" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.BloodPressure}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef='ExamComplete'>
            <mat-header-cell *matHeaderCellDef mat-sort-header>Exam Complete
                <filter class="mat-filter" [data]="angularMatData" columnName="ExamComplete" dataType="boolean"
                    [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'" [showFalseLabel]="''"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span *ngIf="row.ExamComplete" style="padding-right: 30px;">Y</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef='Referral'>
            <mat-header-cell *matHeaderCellDef mat-sort-header>Referral
                <filter class="mat-filter" [data]="angularMatData" columnName="Referral" dataType="boolean"
                    [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'" [showFalseLabel]="''"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span *ngIf="row.Referral" style="padding-right: 30px;">Y</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef='ReferralReturnedToSchool'>
            <mat-header-cell *matHeaderCellDef mat-sort-header>Referral Returned to School
                <filter class="mat-filter" [data]="angularMatData" columnName="ReferralReturnedToSchool"
                    dataType="boolean" [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'"
                    [showFalseLabel]="''"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span *ngIf="row.ReferralReturnedToSchool" style="padding-right: 30px;">Y</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ReturnDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Return Date
                <filter class="mat-filter" [data]="angularMatData" columnName="ReturnDate" dataType="date"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span *ngIf="row.ReturnDate != null && row.ReturnDate != '0001-01-01T00:00:00'">
                    {{row.ReturnDate|date:'MM/dd/yyyy'}}
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef='DoctorDidExam'>
            <mat-header-cell *matHeaderCellDef mat-sort-header>Doctor did Exam
                <filter class="mat-filter" [data]="angularMatData" columnName="DoctorDidExam" dataType="boolean"
                    [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'" [showFalseLabel]="''"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span *ngIf="row.DoctorDidExam" style="padding-right: 30px;">Y</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef='ClinicDidExam'>
            <mat-header-cell *matHeaderCellDef mat-sort-header>Clinic did Exam
                <filter class="mat-filter" [data]="angularMatData" columnName="ClinicDidExam" dataType="boolean"
                    [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'" [showFalseLabel]="''"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span *ngIf="row.ClinicDidExam" style="padding-right: 30px;">Y</span>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay;"></mat-row>
    </mat-table>
</div>